
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/california",
      function () {
        return require("private-next-pages/california.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/california"])
      });
    }
  